// Global Shopify Storefront Access Tokens
// Usage: import or include this file wherever you need the access token

window.shopifyStorefrontAccessTokens = {
  "https://dmfluxury.com" : "37d38b7fd18be490695493aaede02ac7",
  "https://dmf-uat.myshopify.com" : "37d38b7fd18be490695493aaede02ac7",
  "https://portaldmf-test.myshopify.com" : "0b4819e23e8261ac29f4b1a52de5c8da",
  "https://dmf-dev-1.myshopify.com": "aef32693fd14e66fdefc613ebcf691b1",
  "https://dmf-luxury-20-uat.myshopify.com": "6070c2e488b0b1c736c37f3669fbf132"
}; 